import { Button, Card, CardBody } from "reactstrap";
import dummyUserImage from "../../assets/dummy-user.png";
import { FaStar } from "react-icons/fa6";
import { RatingsIcon } from "../../assets/designedPickedIcons";

const ReviewCard = ({ by, ratings, review, profilePicture }) => {
  const renderStars = () => {
    let stars = [];
    for (let i = 1; i <= ratings; i++)
      stars.push(
        <RatingsIcon
          className="d-block"
          size={20}
          color={i < ratings ? "rgba(255, 195, 39, 1)" : "grey"}
        />
      );

    return stars;
  };

  return (
    <Card className="bg-transparent border-none mb-3">
      <CardBody>
        <div className="d-flex justify-content-between mb-2">
          <div className="d-flex gap-2">
            <img
              src={profilePicture ?? dummyUserImage}
              height={42}
              width={42}
              className="avatar"
            />
            <div>
              <h5 className="f-5 baloo-font mb-1">{by?.name}</h5>
              <div className="d-flex align-items-center gap-2">
                {renderStars()}{" "}
                <h6 className="m-0 color-primary-green-1">{ratings}</h6>
              </div>
            </div>
          </div>
        </div>
        <h5 style={{ lineHeight: "normal" }} className="f-5 baloo-font m-0">
          {review}
        </h5>
        {/* <Button
          style={{
            border: "1px solid rgba(50, 42, 42, 1)",
            borderRadius: "50px",
          }}
          className="text-black bg-transparent py-1 mt-2 px-4 f-5 "
        >
          Reply
        </Button> */}
      </CardBody>
    </Card>
  );
};

export default ReviewCard;
